import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../../_services/_nav.service';
import { TranslateService } from '@ngx-translate/core';
import { VigenciasSolicitudes } from '../../../_models/vigencias';


@Component({
  moduleId: module.id,
  templateUrl: './validity-requests.component.html',
  selector: 'validity-requests-component'
})
export class ValidityRequestsComponent implements OnInit {

  @Input() listValidityRequests: VigenciasSolicitudes[] = [];
  busqueda: string;
  columnas: any[] = [];

  constructor( private router: Router,
               private _nav: NavService,
               private translateService: TranslateService) {
    this.busqueda = _nav.getSearch( 'document-management' );

  }

  ngOnInit(): void {
    this.setEncabezadoTable();
  }

  async setEncabezadoTable(){
    this.columnas = [
       { field: 'paso', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_PASO' ).toPromise(), sort: false },
       { field: 'indicadorTipo', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_VIGENCIAAPLICADA' ).toPromise(), sort: false },
       { field: 'vigencia', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_TIPOVIGENCIA' ).toPromise(), sort: false },
       { field: 'duracionVigencia', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_VIGENCIA' ).toPromise(), sort: false },
       { field: 'acciones', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_ACCIONES' ).toPromise(), sort: false },
    ];
 }

 edit(row: VigenciasSolicitudes){
   this.router.navigate([`/apl/vigencias/validity-requests-edit/${row.idVigenciaSolicitud}`]);
}

  setSearch() {
    this._nav.setSearch( 'document-management', this.busqueda );
  }

}
